var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHistorySelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5386\u53F2\u8BB0\u5F55") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-6\\u5907\\u4EFD-8",
    transform: "translate(-609.000000, -25.000000)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-16",
    transform: "translate(500.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8\\u5907\\u4EFD-2",
    transform: "translate(84.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5386\\u53F2\\u8BB0\\u5F55",
    transform: "translate(25.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    opacity: 0,
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,3.63636362 C9.23636363,3.63636362 3.63636362,9.23636363 3.63636362,16 C3.63636362,22.7636364 9.23636363,28.3636364 16,28.3636364 C22.7636364,28.3636364 28.3636364,22.8363637 28.3636364,16 C28.3636364,9.16363634 22.8363636,3.63636362 16,3.63636362 Z M21.3090909,16.4363636 C21.3818182,17.0909091 20.8727273,17.6 20.2909091,17.6 L16.4363636,17.6 C16.2181818,17.6727273 15.9272727,17.6 15.5636364,17.6 L15.4909091,17.6 C14.8363636,17.6 14.3272727,17.8181818 14.3272727,17.1636364 L14.3272727,10.1818182 C14.3272727,9.52727272 14.9090909,9.01818181 15.4909091,9.01818181 C16.1454546,9.01818181 16.6545455,9.6 16.6545455,10.1818182 L16.6545455,15.2 L20.1454545,15.2 C20.8,15.2 21.2363636,15.7090909 21.2363636,16.2909091 C21.3090909,16.3636364 21.3090909,16.4363636 21.3090909,16.4363636 L21.3090909,16.4363636 Z",
    id: "\\u5F62\\u72B6"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistorySelected);
export default __webpack_public_path__ + "static/media/history-selected.9e3acd93b0fac0d8197e40afe76d2a0b.svg";
export { ForwardRef as ReactComponent };